module.exports = __webpack_public_path__ + "static/img/gaozhongzhengzhi3.f04886de.jpg";